module.exports = __webpack_public_path__ + "static/media/DOGE-BNB.0e539d82.svg";